import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { inject } from '@angular/core';

export const AuthGuard: CanActivateFn = (route, state) => {
  console.log("AuthGuard canActivate...");

  const authService = inject(AuthenticationService);
  const router = inject(Router);

  const tokenCheck = authService.isAuthenticated()

  if (tokenCheck) {
    // logged in so return true
    // authService.setupNiederlassung();
    return true;
  } else {
    // not logged in so redirect to login page with the return url
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
};
